import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

const getColor = (severity: number) => {
    switch (severity) {
        case 2:
            return `var(--color-warning)`;
        case 3:
            return `var(--color-error)`;
    }
    return `var(--color-info)`;
};

const getBackgroundColor = (severity: number) => {
    switch (severity) {
        case 2:
            return `var(--color-warning-light)`;
        case 3:
            return `var(--color-error-light)`;
    }
    return `var(--color-info-light)`;
};

export const StyledIncidentMessage = styled.div<{ $severity: number }>`
    position: relative;
    align-items: center;
    justify-content: center;
    padding: 10px 54px 10px 16px;
    font-size: var(--size-16);
    @media ${breakpoints.xs} {
        font-size: var(--size-14);
        padding: 10px 46px 10px 16px;
    }
    line-height: 24px;
    text-align: center;
    color: ${(props) => getColor(props.$severity)};
    background: ${(props) => getBackgroundColor(props.$severity)};
    a {
        font-weight: bold;
        color: ${(props) => getColor(props.$severity)};
    }

    .pointer {
        position: absolute;
        top: calc(50% - 1.0433rem);
        right: 16px;
    }
    .swiper-slide {
        display: flex;
        justify-content: center;
        height: auto;
        vertical-align: middle;
    }
    .swiper-button-next,
    .swiper-button-prev {
        position: absolute;
        top: 50%;
        display: none;
        width: calc(20px / 44 * 27);
        height: 20px;
        margin-top: calc(0px - (20px / 2));
        color: unset;
        &::after {
            font-size: var(--size-20);
        }
    }
    .message {
        display: flex;
        align-items: center;
        justify-content: center;
        svg {
            margin-right: 16px;
        }
    }
`;
